/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_wks-ext.js
 ** module id = 481
 ** module chunks = 0
 **/